import { ICartInput, Prerequisite } from "@types";
import { FC } from "react";
import PrerequisiteSearch from "./prequestSearch";
import ProgramListCard from "./ProgramListCard";

interface Props {
  items: ICartInput[];
  otherPreRequests: Prerequisite[];
}

const PrerequestCourses: FC<Props> = ({ items, otherPreRequests }) => {
  const searchTerms = (otherPreRequests || []).filter((st) => st.url);
  if (!items?.length && !searchTerms?.length) return null;
  return (
    <div className="flex w-full space-y-4 my-2 flex-col py-6">
      <h4 className="headline-sm sm:headline-md text-fds-primary">
        پیش‌نیازها
      </h4>
      <div className="flex flex-col w-full gap-2">
        {(items || []).map((prerequest, idx) => {
          return <ProgramListCard key={idx} data={prerequest} />;
        })}
        {searchTerms.map((preItem) => {
          return <PrerequisiteSearch data={preItem} key={preItem.id} />;
        })}
      </div>
    </div>
  );
};

export default PrerequestCourses;
